import Nav from '../../components/Nav';
import Main from '../../components/Main/';

function Home() {
    return(
        <div>
            <Nav />
            <Main />
        </div>
    )
}

export default Home;